<div class="flex">
  <div class="flex--nogrow ps-xsmall-r">
    <fcom-icon [name]="'single-pax'"></fcom-icon>
  </div>
  <div class="flex-1 font-body-1">
    <div class="flex flex--wrap flex--middle">
      <h2 class="header-title nordic-blue-900-text font-heading-5 ps-small-r">
        {{ extendedPassenger.firstName }} {{ extendedPassenger.lastName }}
      </h2>
      <span class="font-body-1 medium-type"
        >{{ 'passenger.' + extendedPassenger.paxTypeKey | finLocalization | titlecase }}
        {{ 'passenger.age.' + extendedPassenger.paxTypeKey | finLocalization | titlecase }}
      </span>
    </div>
    <div class="flex flex--center ps-xsmall-t">
      <div class="flex-1 flex--self-start">
        <span *ngIf="extendedPassenger.dateOfBirth">
          {{ extendedPassenger.dateOfBirth | finDateFormat: 'DATE' }}
        </span>
        <span *ngIf="extendedPassenger.dateOfBirth && extendedPassenger.email"> / </span>
        <span *ngIf="extendedPassenger.email"> {{ extendedPassenger.email | lowercase }} </span>
        <span *ngIf="extendedPassenger.phoneNumbers?.length > 0">
          <ng-container *ngFor="let phone of extendedPassenger.phoneNumbers; let first = first"
            ><span *ngIf="!first"> / </span
            ><span> / (+{{ phone?.countryPrefix }}) {{ phone?.number }} </span></ng-container
          >
        </span>
        <span *ngIf="extendedPassenger.frequentFlyerCards?.length > 0">
          <ng-container *ngFor="let card of extendedPassenger.cards; let first = first"
            ><span *ngIf="!first"> / </span><span> / {{ card.airlineName }}, {{ card.cardNumber }}</span></ng-container
          >
        </span>
      </div>
    </div>
  </div>

  <div class="flex--nogrow flex--self-center" *ngIf="showEdit">
    <fcom-button
      (click)="onOpenEditModal()"
      [text]="'purchase.actions.edit' | finLocalization"
      [theme]="ButtonTheme.SECONDARY"
      [disabled]="isSaving$ | async"
      [icon]="{ category: 'svg-library', name: 'edit', position: IconPosition.RIGHT }"
    ></fcom-button>
  </div>
  <ng-container *ngIf="passengerFormGroup">
    <fcom-modal
      [title]="'purchase.actions.modifyPax' | finLocalization"
      [open]="editingPassenger$ | async"
      [fitToContent]="true"
      [overlayClickable]="(isSaving$ | async) === false"
      [buttons]="ModalButtons.CONTINUE_CANCEL"
      (close)="onCloseEditModal()"
      (confirm)="onConfirmEditModal()"
    >
      <div class="pr-large-x pr-medium-y" [formGroup]="passengerFormGroup.group">
        <div class="flex">
          <fcom-icon [name]="'single-pax'"></fcom-icon>
          <h2 class="header-title nordic-blue-900-text font-heading-5 ps-small-r">
            {{ extendedPassenger.firstName }} {{ extendedPassenger.lastName }}
          </h2>
          <span class="font-body-1 medium-type"
            >{{ 'passenger.' + extendedPassenger.paxTypeKey | finLocalization | titlecase }}
            {{ 'passenger.age.' + extendedPassenger.paxTypeKey | finLocalization | titlecase }}
          </span>
        </div>
        <fin-pax-details-form-group
          [groupIndex]="paxIndex"
          [passengerFormGroup]="passengerFormGroup.group"
          [profileType$]="profileType$"
          [isMainPassenger]="isMainPax"
          [controlData]="controlData$ | async"
          [frequentFlyerAirlines$]="frequentFlyerAirlines$"
          [allFrequentFlyerCards]="allFrequentFlyerCards$ | async"
          [availableDates]="availableDays"
          [trackingContext]="TRACKING_CONTEXT"
        >
        </fin-pax-details-form-group>
      </div>
    </fcom-modal>
  </ng-container>
</div>
